<template>
  <div>
    <button
      onclick="document.querySelector('body').webkitRequestFullscreen();this.remove()"
      class="fullscreen"
    >Fullscreen</button>
    <section class="wrapper wrapper--tablet">
      <section class="control">
        <div class="control__section control__section--new">
          <h2 v-html="langValue('LANG_ORDERS_NEW')"/>
          <div class="control__grid control__scroll">
            <OrderBox :order="order" v-for="order in newOrderList" :key="order.id" @edit="onOrderEdit(order)" @click="onOrderAdvance(order)"></OrderBox>
          </div>
        </div>

        <div class="control__section control__section--preparation">
          <h2 v-html="langValue('LANG_ORDERS_PREP')"/>
          <div class="control__grid control__scroll control__scroll--high">
            <OrderBox :order="order" v-for="order in prepOnlyOrderList" :key="order.id" @edit="onOrderEdit(order)" @click="onOrderAdvance(order)"></OrderBox>
          </div>
        </div>

        <div v-if="hasFeature('FEATURE_ORDERBOXES') && hasFeature('FEATURE_PREPAREBOXES')" class="control__section control__section--pick-up">
          <h2 v-html="langValue('LANG_ORDERS_PREP_BOX')"/>
          <div
            class="control__grid control__grid--pick-up control__scroll"
            :class="[
              `control__grid--cols-${boxColumns}`
            ]"
          >
            <OrderBox :order="order" v-for="order in prepareOrderList" :key="order.box" @edit="onOrderEdit(order)" @click="onOrderAdvance(order)"></OrderBox>
          </div>
        </div>

        <div class="control__section control__section--pick-up">
          <h2 v-html="langValue('LANG_ORDERS_PICKUP')"/>
          <div
            class="control__grid control__scroll"
            :class="[
              hasFeature('FEATURE_ORDERBOXES') ? `control__grid--cols-${boxColumns}` : '',
              {
                'control__grid--pick-up' : hasFeature('FEATURE_ORDERBOXES'),
              }
            ]"
          >
            <template  v-if="hasFeature('FEATURE_ORDERBOXES')">
              <OrderBox :order="order" v-for="order in pickupOrderBoxList" :key="order.box" @edit="onOrderEdit(order)" @click="onOrderAdvance(order)"></OrderBox>
            </template>
            <template v-else>
              <OrderBox :order="order" v-for="order in pickupOrderList" :key="order.id" @edit="onOrderEdit(order)" @click="onOrderAdvance(order)"></OrderBox>
            </template>
          </div>
        </div>

        <button
          v-if="hasFeature('FEATURE_PASTORDERS')"
          type="button"
          class="control__past-orders-button"
          @click="onPastOrdersOpen"
        >Past Orders</button>
      </section>
    </section>

    <OverlayPastOrders
      v-if="hasFeature('FEATURE_PASTORDERS')"
      v-model="overlayPastOpen"
      :list="pastOrderList"
      @changestate="onPastOrderEdit"
      @close="overlayPastClose"
    />

    <OverlayOrderUpdate
      v-model="overlayOpen"
      @changestate="onOverlaySelect"
      :order="overlayOrder"
      :currentPickups="pickupOrderBoxList"
      :currentPrepare="prepareOrderList"
      :box-columns="boxColumns"
    ></OverlayOrderUpdate>

  </div>
</template>

<script>
import OverlayOrderUpdate from '@num/components/OverlayOrderUpdate'
import OverlayPastOrders from '@num/components/OverlayPastOrders'
import OrderBox from '@num/components/OrderBox'
import MixinOrderList from '@num/mixins/MixinOrderList'
import { startUpdateOrderListInterval, updateOrder, advanceOrder } from "@num/controller";

export default {
  mixins: [
    MixinOrderList
  ],
  components: {
    OverlayOrderUpdate,
    OverlayPastOrders,
    OrderBox
  },
  data() {
    let uniqueOrderId = 0
    return {
      loading: false,
      overlayOpen: false,
      overlayOrder: null,
      overlayPastOpen: false,
    };
  },
  methods: {
    onOverlayClose() {
      this.overlayOpen = false
    },
    onOrderAdvance(order) {
      if (order.status != "empty") {
        advanceOrder(order)
          .catch(err => {
            if (err.code == 2) {
              //gracefully ignore no boxes free
              return Promise.resolve()
            }
            return Promise.reject(err)
          })
      }
    },
    onOrderEdit(order) {
      if (order.status != "empty") {
        this.overlayOrder = order
        this.overlayOpen = true
      }
    },
    onPastOrdersOpen() {
      this.overlayPastOpen = true
    },
    overlayPastClose() {
      this.overlayPastOpen = false
    },
    onPastOrderEdit(order) {
      this.onOrderEdit(order)
    },
    onOverlaySelect(status) {
      if (this.overlayOrder) {
        updateOrder({ id: this.overlayOrder.id, status})
      } else {
        throw new Error("PageControl: No order for overlay available")
      }
      this.overlayOrder = null
      this.overlayOpen = false
      this.overlayPastOpen = false
    }
  },
  mounted() {
    startUpdateOrderListInterval()
  }
};
</script>

<style>
</style>
